import Monitor from "../icons/monitor.svg"
import Data from "../icons/data.svg"
import Clock from "../icons/clock.svg"
import Completed from "../icons/completeddp.svg"
import Failed from "../icons/failed.svg"
import MaintenanceCompleted from "../icons/maintenance-completed.svg"
import MaintenanceFailed from "../icons/maintenance-failed.svg"
import Settings from "../icons/settings.svg"
import ModelMetaData1 from "../icons/ModelMetaData1.svg"
import HarmonizationIcon from "../icons/harmonization.svg"
import IssueTracker from "../icons/issue_tracker.svg"

import InProgress from "../icons/inprogressdp.svg"
import Pipeline from "../icons/pipelinedp.svg"
import {
  IDropDownOptions,
  IFeatureDriftCard,
  IMetaDataCard,
  IModelMetaDataCard,
  IMonitorCardInterface,
  IMonthlyStaticOption,
  INavigationMenu,
  IPipelineData,
  PipelineStatusCodes,
} from "./interface"
import { Task } from "gantt-task-react"
import { AlertColor } from "@mui/material"
import { eachYearOfInterval, format } from "date-fns"
import { Bounce, ToastOptions } from "react-toastify"
import { CreateDropDownOptions } from "./CommonMethods"
import { newPipeLineTypes } from "./NewPipelineConfig"

export const ADF_LINK =
  "https://adf.azure.com/en/monitoring/pipelineruns?factory=%2Fsubscriptions%2F717b9179-2bcb-4f59-a562-839a9b4c2d52%2FresourceGroups%2FRG-DATALAB-KOFANALITCORPO-QA%2Fproviders%2FMicrosoft.DataFactory%2Ffactories%2Fdfdatalab01qa"

export const viewMorePipelineData: IPipelineData[] = [
  {
    name: "Progress :",
    value: "",
    src: "",
    key: "progress",
    percentage: 0,
  },
  {
    name: "Stage Currently :",
    value: "",
    src: "",
    key: "current_activity",
  },
  {
    name: "Last Activity Completed :",
    value: "",
    src: "",
    key: "last_activity_completed",
  },
]

export const defaultPipelineData: IPipelineData[] = [
  {
    name: "Pipeline Name :",
    value: "",
    src: "",
    key: "name",
  },
  {
    name: "Market :",
    value: "",
    src: "",
    key: "market_place",
  },
  {
    name: "Pipeline Stage :",
    value: "",
    src: "",
    key: "current_stage",
  },
  {
    name: "Progress :",
    value: "",
    src: "",
    key: "progress",
    percentage: 0,
  },
  // {
  //   name: "Segment Completed Status :",
  //   value: "10/11",
  //   src: "",
  // },
  {
    name: "Start Date & Time :",
    value: "",
    src: "",
    key: "start_time",
  },
  {
    name: "End Date & Time :",
    value: "",
    src: "",
    key: "end_time",
  },
  {
    name: "Total Execution Time:",
    value: "",
    src: "",
    key: "total_execution_time",
  },
  {
    name: "Parameters Passed :",
    value: "",
    src: "",
    key: "parameters_passed",
  },
]
export const SCREENS_DETAILS = {
  MONITORING: "monitor",
  DATA_METADATA: "data-metadata",
  MODEL_META_DATA: "model-metadata",
  WEB_SCRAPING: "web-scraping",
  MAINTENANCE: "maintenance",
  DATA_HARMONIZATION: "harmonization",
  CREATE_SCENARIO: `/harmonization/create-scenario`,
  MAPPING_INSIGHTS: `/harmonization/mapping-insights`,
  DATA_QUALITY: "quality",
  ISSUE_TRACKER: "issue-tracker",
}

export const NAV: INavigationMenu = {
  "monitoring overview": {
    key: "monitoring overview",
    label: "Monitoring Overview",
    route: "/monitor",
    svg: Monitor,
    child: [
      {
        key: "data metadata",
        label: "Data Metadata",
        svg: Data,
        // route: "/data-metadata-raw-data",
        route: `/${SCREENS_DETAILS.DATA_METADATA}?tab=RDQ`,
      },
      {
        key: "model metadata",
        label: "Model Metadata",
        route: `/${SCREENS_DETAILS.MODEL_META_DATA}?tab=MAPE`,
        svg: ModelMetaData1,
      },
    ],
  },
  maintainance: {
    key: "maintainance",
    label: "Maintenance",
    svg: Settings,
    route: `/${SCREENS_DETAILS.MAINTENANCE}`,
  },
  isssue_tracker: {
    key: "issue tracker",
    label: "AI Enabled Issue Tracker",
    svg: IssueTracker,
    route: `/${SCREENS_DETAILS.ISSUE_TRACKER}`,
    // child: [
    // {
    //   key: "config maintainance",
    //   label: "Config Maintainance",
    //   svg: Data,
    //   route: `/${SCREENS_DETAILS.MAINTENANCE}`,
    // route:"/data-metadata-raw-data"
    // },
    // {
    //   key: "model metadata",
    //   label: "Model Metadata",
    //   svg: Data,
    // },
    // ],
  },
  "ai enabled harmonization": {
    key: "ai enabled harmonization",
    label: "AI Enabled Harmonization",
    svg: HarmonizationIcon,
    route: `/${SCREENS_DETAILS.DATA_HARMONIZATION}`,
  },
  "ai enabled quality": {
    key: "ai enabled quality",
    label: "AI Enabled Quality",
    svg: Monitor,
    route: `/${SCREENS_DETAILS.DATA_QUALITY}`,
  },
}
export const timePeriodDescription: any = {
  week: "In this week",
  month: "In this month",
  year: "In this year",
}

export const MONITOR_CARDS: IMonitorCardInterface[] = [
  {
    label: "PIPELINES",
    decription: "In this week",
    score: 0,
    hasHighLow: false,
    percentage: 0,
    svg: Pipeline,
    runs: "0",
    identifier: "pipelines",
    percentageKey: "",
  },
  {
    label: "PIPELINE ID",
    decription: "In this week",
    score: 0,
    hasHighLow: false,
    percentage: 0,
    svg: Pipeline,
    runs: "0",
    identifier: "pipelineid",
    percentageKey: "",
  },
  {
    label: "Scheduled",
    decription: "vs LW",
    score: 0,
    hasHighLow: true,
    percentage: 0,
    runs: "0",
    svg: Clock,
    identifier: "scheduled",
    percentageKey: "scheduled_percentage_change",
    executionStatusCode: 4,
  },
  {
    label: "In progress",
    decription: "vs LW",
    score: 0,
    hasHighLow: true,
    percentage: 0,
    runs: "0",
    svg: InProgress,
    identifier: "inProgress",
    percentageKey: "running_percentage_change",
    executionStatusCode: 1,
  },
  {
    label: "Completed",
    decription: "vs LW",
    score: 0,
    hasHighLow: true,
    percentage: 0,
    runs: "0",
    svg: Completed,
    identifier: "completed",
    percentageKey: "success_percentage_change",
    executionStatusCode: 3,
  },
  {
    label: "Failed",
    decription: "vs LW",
    score: 0,
    runs: "0",
    hasHighLow: true,
    percentage: 0,
    svg: Failed,
    identifier: "failed",
    percentageKey: "failure_percentage_change",
    executionStatusCode: 0,
  },
  // {
  //   label: "Graceful Shutdown",
  //   decription: "vs LW",
  //   score: 0,
  //   hasHighLow: true,
  //   percentage: 1,
  //   svg: ShutDown,
  //   identifier: 'gracefulShutdown'
  // },
]

export const ITEM_HEIGHT = 48
export const ITEM_PADDING_TOP = 8

export const useCaseOptions: IDropDownOptions[] = [
  { value: "promo1", label: "Promo 1", isFixed: true },
  { value: "promo2", label: "Promo 2" },
  { value: "promo3", label: "Promo 3", isFixed: true },
]

export const marketOptions: IDropDownOptions[] = [
  { value: "market1", label: "Market 1", isFixed: true },
  { value: "market2", label: "Market 2" },
  { value: "market3", label: "Market 3", isFixed: true },
]

export const timePeriodOptions: IDropDownOptions[] = [
  { value: "week", label: "Weekly", isFixed: true },
  { value: "month", label: "Monthly", isFixed: true },
  // { value: "year", label: "Yearly" },
]
export const timePeriodOptionsMaintenance: IDropDownOptions[] = [
  { value: "day", label: "Daily" },
  ...timePeriodOptions,
]
export const modelMetaDataViewByTableOptions: IDropDownOptions[] = [
  { value: "category", label: "Category", isFixed: true },
  { value: "region", label: "Region", isFixed: true },
  // { value: "year", label: "Yearly" },
]
export const DAYS = {
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
}
export const DAYS_TO_NUMBER_MAPPER: any = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
}
export const MONTHS: any = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]
export const MONTHS_DISPLAY_MAPPER: any = {
  January: "Jan",
  February: "Feb",
  March: "Mar",
  April: "Apr",
  May: "May",
  June: "Jun",
  July: "Jul",
  August: "Aug",
  September: "Sep",
  October: "Oct",
  November: "Nov",
  December: "Dec",
}
export const monthOptions: IDropDownOptions[] = CreateDropDownOptions(MONTHS)
const startDate = new Date("2018-01-01")
const endDate = new Date()

// Get an array of years within the date range
const yearsArray = eachYearOfInterval({ start: startDate, end: endDate })

// Extract only the years
const years = yearsArray.map((year) => format(year, "yyyy"))
export const yearOptions: IDropDownOptions[] = CreateDropDownOptions(years)
export const timePeriodMapper: any = {
  week: "Weekly",
  month: "Monthly",
  year: "Yearly",
  category: "Category",
  region: "Region",
  day: "Daily",
}
export const weekAndMonthMapper: any = {
  week: "Weekly",
  month: "Monthly",
  day: "Daily",
}
export const weekAndMonthMapperMaintenanceChart: any = {
  ...weekAndMonthMapper,
  week: "Weekly",
}

export const NewPipeLineStaticData = [
  {
    profiling: "True",
    tableName: "Calendar",
    location: "True",
    recreate: "True",
    specialCharacter: "True",
    fileFormat: "Delta",
  },
  {
    profiling: "True",
    tableName: "Calendar",
    location: "False",
    recreate: "True",
    specialCharacter: "True",
    fileFormat: "Delta",
  },
  {
    profiling: "True",
    tableName: "Calendar",
    location: "False",
    recreate: "True",
    specialCharacter: "True",
    fileFormat: "Delta",
  },
  {
    profiling: "True",
    tableName: "Calendar",
    location: "False",
    recreate: "True",
    specialCharacter: "True",
    fileFormat: "Delta",
  },
  {
    profiling: "True",
    tableName: "Calendar",
    location: "False",
    recreate: "True",
    specialCharacter: "True",
    fileFormat: "Delta",
  },
  {
    profiling: "True",
    tableName: "Calendar",
    location: "False",
    recreate: "True",
    specialCharacter: "True",
    fileFormat: "Delta",
  },
]
export enum API_STATUS {
  LOADING = "loading",
  IDLE = "idle",
  FAILED = "failed",
}

export const ALERT_STATUS_MSGS: { [key: string]: AlertColor } = {
  SUCCESS: "success",
  INFO: "info",
  WARN: "warning",
  ERROR: "error",
}
export const ALERT_MSGS = {
  PIPELINE: {
    SCHEDULE_SUCCESS: "Pipeline scheduled successfully.",
    SCHEDULE_FAILED: "Pipeline schedule failed.",
    EXECUTION_STARTEDD: "Pipeline execution started.",
    EXECUTION_FAILED: "Failed to run pipeline.",
    CONFIG_UPDATE_FAILED: "Failed to update the config data.",
    CONFIG_UPDATE_SUCCESS: "Config data updated successfully!",
    PAST_TIME: "Selected time should not be past.",
  },
  DATA_META_DATA: {
    REPORT_NOT_AVAILABLE: "Reports not available for",
  },
}

export enum CLUSTER_OPTIONS {
  MEMORY = "Cluster Memory",
  LOAD = "Cluster Load",
}

export enum GANTT_OPTIONS {
  WEEKLY = "Week",
  MONTHYLY = "Month",
  DAILY = "Day",
  // QUARTER_DAY = "Quarter Day",
  // HALF_DAY = "Half Day",
}
export enum DATA_TYPES {
  number,
  string,
  boolean,
}

export const colorMapperGant: any = {
  [PipelineStatusCodes.FAILURE]: "#E21824",
  [PipelineStatusCodes.RUNNING]: "#27AF8D",
  [PipelineStatusCodes.SUCCESS]: "#2C7E98",
  [PipelineStatusCodes.UNKNOWN]: "#F6BB42",
  [PipelineStatusCodes.SCHEDULED]: "#F6BB42",
}
export const colorMapperGantMaintenance: any = {
  ...colorMapperGant,
  [PipelineStatusCodes.RUNNING]: "",
}
export const textMapperGant: any = {
  [PipelineStatusCodes.FAILURE]: "Failed",
  [PipelineStatusCodes.RUNNING]: "In Progress",
  [PipelineStatusCodes.SUCCESS]: "Completed",
  [PipelineStatusCodes.UNKNOWN]: "Unknown",
  [PipelineStatusCodes.SCHEDULED]: "Scheduled",
}
export const pipeLineStatusIcons: any = {
  [PipelineStatusCodes.FAILURE]: MaintenanceFailed,
  [PipelineStatusCodes.RUNNING]: InProgress,
  [PipelineStatusCodes.SUCCESS]: MaintenanceCompleted,
  [PipelineStatusCodes.UNKNOWN]: "Unknown",
  [PipelineStatusCodes.SCHEDULED]: Clock,
}

export const nodeColorMapper: any = {
  Failed: "failed",
  "In Progress": "inprogress",
  Completed: "completed",
  Scheduled: "scheduled",
}

export const maxWidth = 140
export const minWidth = 90
export const booleanOptions = CreateDropDownOptions(["True", "False"])
export const fileFormatOptions = CreateDropDownOptions(["Delta", "xlxs", "csv"])

export const DEEP_DIVE_DATA = {
  data: {
    id: 213,
    name: "",
    market_place: {
      id: 35,
      name: "",
    },
    last_run: {
      id: 1263,
      execution_status: 3,
      start_time: "2023-10-19T07:30:14.422409Z",
      end_time: "2023-10-19T07:31:45.960072Z",
      progress: 100.0,
      current_stage: "",
      last_activity_completed: "",
      current_stage_time: "2023-10-27T12:20:05.018145Z",
      pipeline: 213,
      input: [],
      output: [],
    },
  },
}

export const ALL_OPTION = "All"

export function initTasks() {
  let tasks: any = [
    {
      start: "2023-10-30T18:30:00.000Z",
      end: "2023-10-30T18:30:00.000Z",
      name: "dev_co_promo_orchestration_pipeline_1",
      id: "dev_co_promo_orchestration_pipeline_1",
      progress: 0,
      type: "project",
      hideChildren: false,
      displayOrder: 1,
      isDisabled: true,
      styles: {
        backgroundColor: "white",
        progressColor: "white",
        progressSelectedColor: "white",
        backgroundSelectedColor: "white",
      },
    },
    {
      start: "2023-10-29T07:30:00.602Z",
      end: "2023-10-29T07:31:21.932Z",
      name: "Failed",
      id: "17553890-00e4-4021-bff1-48f0536719c4",
      type: "task",
      progress: 0,
      project: "dev_co_promo_orchestration_pipeline_1",
      isDisabled: false,
      displayOrder: 1,
      styles: {},
    },
    {
      start: "2023-11-03T06:10:53.231Z",
      end: "2023-11-03T06:12:00.545Z",
      name: "Failed",
      id: "be8dbf8a-7a0f-11ee-b69c-c03c5952c9f1",
      type: "task",
      progress: 0,
      project: "dev_co_promo_orchestration_pipeline_1",
      isDisabled: false,
      displayOrder: 2,
      styles: {},
    },
  ]

  tasks = tasks.map((task: Task) => {
    return {
      ...task,
      start: new Date(task.start),
      end: new Date(task.end),
    }
  })
  return tasks
}
export const maintenanceViews = {
  sideview: "sideView",
  dialogView: "dialogView",
}
export const staticFilterOptions: any = [{ value: "", label: "" }]
export const DATE_FORMAT = "dd/MM/yyyy"
export const timeZoneOptions = CreateDropDownOptions([
  "Afghanistan Standard Time",
  "FLE Standard Time",
  "Central Europe Standard Time",
  "W. Central Africa Standard Time",
  "UTC-11",
  "W. Europe Standard Time",
  "SA Western Standard Time",
  "Pacific SA Standard Time",
  "Argentina Standard Time",
  "Caucasus Standard Time",
  "AUS Eastern Standard Time",
  "Azerbaijan Standard Time",
  "Eastern Standard Time",
  "Arab Standard Time",
  "Bangladesh Standard Time",
  "Belarus Standard Time",
  "Romance Standard Time",
  "Central America Standard Time",
  "Atlantic Standard Time",
  "Venezuela Standard Time",
  "Central European Standard Time",
  "South Africa Standard Time",
  "UTC",
  "E. South America Standard Time",
  "Central Asia Standard Time",
  "Singapore Standard Time",
  "Greenwich Standard Time",
  "Cape Verde Standard Time",
  "SE Asia Standard Time",
  "SA Pacific Standard Time",
  "China Standard Time",
  "Myanmar Standard Time",
  "E. Africa Standard Time",
  "Hawaiian Standard Time",
  "E. Europe Standard Time",
  "Tokyo Standard Time",
  "Egypt Standard Time",
  "SA Eastern Standard Time",
  "GMT Standard Time",
  "Fiji Standard Time",
  "West Asia Standard Time",
  "Georgian Standard Time",
  "GTB Standard Time",
  "Greenland Standard Time",
  "West Pacific Standard Time",
  "Mauritius Standard Time",
  "India Standard Time",
  "Iran Standard Time",
  "Arabic Standard Time",
  "Israel Standard Time",
  "Jordan Standard Time",
  "UTC+12",
  "Korea Standard Time",
  "Middle East Standard Time",
  "Central Standard Time (Mexico)",
  "Ulaanbaatar Standard Time",
  "Morocco Standard Time",
  "Namibia Standard Time",
  "Nepal Standard Time",
  "Central Pacific Standard Time",
  "New Zealand Standard Time",
  "Arabian Standard Time",
  "Pakistan Standard Time",
  "Paraguay Standard Time",
  "Pacific Standard Time",
  "Russian Standard Time",
  "Samoa Standard Time",
  "UTC-02",
  "Sri Lanka Standard Time",
  "Syria Standard Time",
  "Taipei Standard Time",
  "Tonga Standard Time",
  "Türkiye Standard Time",
  "Mountain Standard Time",
  "Montevideo Standard Time",
])

export const NOTE_TEXT = {
  REFRESH_CALENDAR:
    "Displays the status information for each run in the pipeline.",
  MONITORING_DEEP_DIVE:
    "Monitors your pipeline across each stage. Tracks your pipeline runs, and offers insights on the progress.",
}
export const META_DATA_KEYS: any = {
  RDQ: "Raw Data Quality",
  AMC: "ADM Mapping Check",
  ISPR: "Input Series Profiling Report",
  CC: "Consistency Check",
  ISQC: "Input Series Quality Check",
  FD: "Feature Drift",
  DDC: "Data Drift Check",
}
export const MODEL_META_DATA_KEY_MAPPER = {
  MAPE: "MAPE",
  R2: "R2",
  Model_Divergence: "Model_Divergence",
  Models_to_be_retrained: "Channels_to_be_retrained",
  Internal_Variable_Contribution: "Internal_Variable_Contribution",
  Coverage: "Coverage",
}
export const BREADCRUMB_MAPPER: any = {
  Model_Divergence: "Divergence",
  Models_to_be_retrained: "Channels to be retrained",
  Internal_Variable_Contribution: "Internal Variable Contribution",
  Coverage: "Model Coverage",
}

export const DATA_META_CARDS: IMetaDataCard[] = [
  {
    title: META_DATA_KEYS.RDQ,
    passCount: 0,
    fail: 0,
    emailTrigger: false,
    progress: 0,
    key: "RDQ",
    file_type: "raw_data_quality",
    toolTipText:
      "Makes sure the data follows the structure we expect and finds any special or missing values in certain columns, keeping the data reliable.",
    emailText: "",
  },
  {
    title: META_DATA_KEYS.DDC,
    passCount: 0,
    fail: 0,
    emailTrigger: false,
    progress: 0,
    file_type: "data_drift",
    key: "DDC",
    emailText: "",
    toolTipText:
      "This drift percentage indicates the percentage change in the KPI value for the current month compared to the average of the previous 12 months.",
  },
  {
    title: META_DATA_KEYS.AMC,
    passCount: 0,
    fail: 0,
    emailTrigger: false,
    progress: 0,
    file_type: "adm_mapping_check",
    key: "AMC",
    emailText: "",
    toolTipText:
      "Verify whether all data from the mapping table has been successfully transferred to the adm/base table by comparing the matching percentages of both tables.",
  },
  // {
  //   title: META_DATA_KEYS.ISPR,
  //   passCount: 0,
  //   fail: 0,
  //   emailTrigger: false,
  //   progress: 0,
  //   key: "ISPR",
  //   emailText: "",
  //   file_type: "input_series_profiling_report",
  //   toolTipText:
  //     "Basic checks to ensure that the features created in the input series make sense for our business needs.",
  // },
  {
    title: META_DATA_KEYS.CC,
    passCount: 0,
    fail: 0,
    emailTrigger: false,
    progress: 0,
    key: "CC",
    emailText: "",
    file_type: "consistency_check",
    toolTipText:
      "Ensures that all data across the adm processed, adm processed summary, and prediction input series are identical.",
  },
  {
    title: META_DATA_KEYS.ISQC,
    passCount: 0,
    fail: 0,
    emailTrigger: false,
    progress: 0,
    key: "ISQC",
    emailText: "",
    file_type: "input_series_quality_check",
    toolTipText:
      "Demonstrates project-specific business logic validations for input series.",
  },
]
export const FEATURE_DRIFT_CARD: IFeatureDriftCard = {
  title: META_DATA_KEYS.FD,
  progress: 0,
  key: "FD",
  file_type: "feature_drift",
  toolTipText: "",
  warnings: 0,
}

export const META_DATA_TABS = {
  RDQ: META_DATA_KEYS.RDQ,
  AMC: META_DATA_KEYS.AMC,
  ISPR: META_DATA_KEYS.ISPR,
  CC: META_DATA_KEYS.CC,
  ISQC: META_DATA_KEYS.ISQC,
  FD: META_DATA_KEYS.FD,
  DDC: META_DATA_KEYS.DDC,
}

export const META_DATA_KEY_MAPPER = {
  RDQ: "RDQ",
  AMC: "AMC",
  ISPR: "ISPR",
  CC: "CC",
  ISQC: "ISQC",
  FD: "FD",
  DDC: "DDC",
}
export const CSV_FILE_NAME_MAPPER: any = {
  [META_DATA_KEY_MAPPER.RDQ]: "Raw Data Quality Report",
  [META_DATA_KEY_MAPPER.AMC]: "ADM Mapping Check Report",
  [META_DATA_KEY_MAPPER.ISPR]: "Input Series Profiling Report",
  [META_DATA_KEY_MAPPER.CC]: "Consistency Check Report",
  [META_DATA_KEY_MAPPER.ISQC]: "Input Series Quality Check Report",
  [META_DATA_KEY_MAPPER.FD]: "Feature Drift Report",
  [META_DATA_KEY_MAPPER.DDC]: "Data Drift Check Report",
}

export const DOWNLOAD_NOTE = {
  RDQ: "*Click here to know more about Raw Data Quality Report",
  AMC: " *Click here to know more about ADM Mapping Check Report",
  ISPR: " *Click here to know more about Input Series Profiling Report",
  CC: " *Click here to know more about Consistency Check Report",
  ISQC: " *Click here to know more about Input Series Quality Check Report",
  DDC: " *Click here to know more about Data Drift Check Report",
  FD: "*Click here to know more about Feature Drift Check Report",
}
export const categoryAndRegionMapper: any = {
  category: "CATEGORY_UPDATED",
  region: "Region",
}
export const PIPELINE_NAMES_MAPPER: any = {
  dev_co_promo_orchestration_pipeline_1: "",
  dev_co_promo_orchestration_pipeline_2: "",
}

const temp = Array.from(Array(32).keys())
  .filter((val, ind) => ind !== 0)
  .map((val) => {
    return { value: val, label: String(val).toString() } // Adjust label as per your requirement
  })

temp.push({ value: -1, label: "Last" })

export const monthlyStaticOptions: IMonthlyStaticOption[] = temp
export const TOAST_OPTS: ToastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  transition: Bounce,
}
export const MODEL_META_DATA_CARDS: IModelMetaDataCard[] = [
  {
    title: "MAPE",
    key: MODEL_META_DATA_KEY_MAPPER.MAPE,
    percentage: "0",
    retrainingPercentage: "0",
    payloadKey: MODEL_META_DATA_KEY_MAPPER.MAPE,
  },
  {
    title: "R2",
    key: MODEL_META_DATA_KEY_MAPPER.R2,
    percentage: "0",
    retrainingPercentage: "0",
    payloadKey: MODEL_META_DATA_KEY_MAPPER.R2,
  },
  {
    title: "Divergence",
    key: MODEL_META_DATA_KEY_MAPPER.Model_Divergence,
    percentage: "0",
    retrainingPercentage: "0",
    payloadKey: MODEL_META_DATA_KEY_MAPPER.Model_Divergence,
  },
  {
    title: "Models to be Retrained",
    key: MODEL_META_DATA_KEY_MAPPER.Models_to_be_retrained,
    percentage: "0",
    retrainingPercentage: "0",
    payloadKey: MODEL_META_DATA_KEY_MAPPER.Models_to_be_retrained,
  },
  {
    title: "Internal Variable Contribution",
    key: MODEL_META_DATA_KEY_MAPPER.Internal_Variable_Contribution,
    percentage: "0",
    retrainingPercentage: "0",
    payloadKey: MODEL_META_DATA_KEY_MAPPER.Internal_Variable_Contribution,
  },
  {
    // title: META_DATA_KEYS.FD,
    title: "Model Coverage",
    key: MODEL_META_DATA_KEY_MAPPER.Coverage,
    percentage: "0",
    retrainingPercentage: "0",
    payloadKey: MODEL_META_DATA_KEY_MAPPER.Coverage,
  },
]
export const MODEL_META_DATA_CONFIGS: any = {
  MAPE: {
    chartHeader: "Mape Trend",
    tableHeader: "Mape Distribution Across Portfolio Hierarchy",
  },
  R2: {
    chartHeader: "R2 Trend",
    tableHeader: "R2 Across Portfolio",
  },
  Model_Divergence: {
    chartHeader: "Divergence Trend",
    tableHeader: "Divergence % Across Portfolio",
  },
  Models_to_be_retrained: {
    chartHeader: "% of Channels to be retrained",
    tableHeader: "% of channels to be retrained Across Portfolio",
  },
  Internal_Variable_Contribution: {
    chartHeader: "Internal Variable Contribution Trend",
    tableHeader: "Internal Variable Contribution Across Portfolio",
  },
  Coverage: {
    chartHeader: "Model Coverage Trend",
    tableHeader: "Model Coverage % Across Portfolio",
  },
}

export const PIPELINE_RESPONSE_STATIC: any = [
  {
    name: "PRICE CR",
    data: [
      {
        start: "2025-06-30T18:30:00.000Z",
        end: "2025-06-30T18:30:00.000Z",
        name: "",
        id: "airflow_promo_dag",
        progress: 0,
        type: "project",
        showToolTip: false,
        hideChildren: false,
        isDisabled: true,
      },
      {
        start: "2025-08-01T06:48:56.939Z",
        end: "2025-08-01T06:52:03.544Z",
        name: "",
        toolTipName: "Completed",
        id: "manual__2025-08-01T06:48:56.409947+00:00",
        scheduled: false,
        type: "task",
        progress: 0,
        project: "airflow_promo_dag",
        isDisabled: true,
        styles: {
          backgroundColor: "#2C7E98",
        },
        status: 3,
      },
      {
        start: "2025-08-01T08:02:09.526Z",
        end: "2025-08-01T08:05:15.897Z",
        name: "",
        toolTipName: "Completed",
        id: "manual__2025-08-01T08:02:08.808823+00:00",
        scheduled: false,
        type: "task",
        progress: 0,
        project: "airflow_promo_dag",
        isDisabled: true,
        styles: {
          backgroundColor: "#2C7E98",
        },
        status: 3,
      },
    ],
    extra: {
      id: 149,
      name: "airflow_promo_dag",
      use_case: {
        id: 5,
        name: "PRICE",
      },
      market_place: {
        id: 6,
        name: "CR",
      },
      is_parent: true,
      runs: [
        {
          execution_status: 3,
          id: 257030,
          start_time: "2025-08-01T06:48:56.939Z",
          end_time: "2025-08-01T06:52:03.544Z",
          parameters: [
            {
              name: "refresh_year_month",
              default_value: "202403",
            },
          ],
          az_pipeline_run_id: "manual__2025-08-01T06:48:56.409947+00:00",
        },
        {
          execution_status: 3,
          id: 255077,
          start_time: "2025-08-01T08:02:09.526Z",
          end_time: "2025-08-01T08:05:15.897Z",
          parameters: [
            {
              name: "refresh_year_month",
              default_value: "202403",
            },
          ],
          az_pipeline_run_id: "manual__2025-08-01T08:02:08.808823+00:00",
        },
      ],
      created_at: "2024-10-07T15:13:54.202Z",
      updated_at: "2025-04-08T18:42:29.738Z",
    },
  },
  {
    name: "GROWTH EXP",
    data: [
      {
        start: "2025-08-01T06:40:54.028Z",
        end: "2025-08-01T06:43:23.794Z",
        name: "",
        id: "airflow_growth_explorer_dag",
        progress: 0,
        type: "project",
        showToolTip: false,
        hideChildren: false,
        isDisabled: true,
      },
      {
        start: "2025-08-01T06:40:54.028Z",
        end: "2025-08-01T06:43:23.794Z",
        name: "",
        toolTipName: "Completed",
        id: "manual__2025-08-01T06:40:53.401104+00:00",
        scheduled: false,
        type: "task",
        progress: 0,
        project: "airflow_growth_explorer_dag",
        isDisabled: true,
        styles: {
          backgroundColor: "#2C7E98",
        },
        status: 3,
      },
    ],
    extra: {
      id: 150,
      name: "airflow_growth_explorer_dag",
      use_case: {
        id: 7,
        name: "GROWTH",
      },
      market_place: {
        id: 3,
        name: "EXP",
      },
      is_parent: true,
      runs: [
        {
          execution_status: 3,
          id: 302101,
          start_time: "2025-08-01T06:40:54.028Z",
          end_time: "2025-08-01T06:43:23.794Z",
          parameters: [
            {
              name: "region",
              default_value: "IN",
            },
          ],
          az_pipeline_run_id: "manual__2025-08-01T06:40:53.401104+00:00",
        },
      ],
      created_at: "2024-11-12T10:00:00.000Z",
      updated_at: "2025-06-01T11:11:11.111Z",
    },
  },
  {
    name: "SALESFORCE ADLS",
    data: [
      {
        start: "2025-08-01T06:41:02.766Z",
        end: "2025-08-01T06:42:56.467Z",
        name: "",
        id: "airflow_salesforce_to_adls_dag",
        progress: 0,
        type: "project",
        showToolTip: false,
        hideChildren: false,
        isDisabled: true,
      },
      {
        start: "2025-08-01T06:41:02.766Z",
        end: "2025-08-01T06:42:56.467Z",
        name: "",
        toolTipName: "Completed",
        id: "manual__2025-08-01T06:41:02.638694+00:00",
        scheduled: false,
        type: "task",
        progress: 0,
        project: "airflow_salesforce_to_adls_dag",
        isDisabled: true,
        styles: {
          backgroundColor: "#2C7E98",
        },
        status: 3,
      },
    ],
    extra: {
      id: 151,
      name: "airflow_salesforce_to_adls_dag",
      use_case: {
        id: 8,
        name: "SALESFORCE",
      },
      market_place: {
        id: 9,
        name: "ADLS",
      },
      is_parent: true,
      runs: [
        {
          execution_status: 3,
          id: 312201,
          start_time: "2025-08-01T06:41:02.766Z",
          end_time: "2025-08-01T06:42:56.467Z",
          parameters: [
            {
              name: "object",
              default_value: "Leads",
            },
          ],
          az_pipeline_run_id: "manual__2025-08-01T06:41:02.638694+00:00",
        },
      ],
      created_at: "2024-12-01T08:30:00.000Z",
      updated_at: "2025-06-30T09:45:00.000Z",
    },
  },
]
export const MAPPING_FOR_PARAMETER: Record<string, string> = {
  refresh_year_month: newPipeLineTypes.inputWithDate,
  model_retraining: newPipeLineTypes.dropDownWithBools,
  update_historic: newPipeLineTypes.dropDownWithBools,
  start_year_month: newPipeLineTypes.inputWithDate,
  end_year_month: newPipeLineTypes.inputWithDate,
  Email_To: newPipeLineTypes.textInput,
}

export const dummyDataforParameters = [
  {
    param_name: "refresh_year_month",
    type: "string",
    default_value: new Date("2024-03-01T00:00:00.000Z"),
  },
  {
    param_name: "model_retraining",
    type: "string",
    default_value: "False", // dropDownWithBools
  },
  {
    param_name: "update_historic",
    type: "string",
    default_value: "False", // dropDownWithBools
  },
  {
    param_name: "start_year_month",
    type: "string",
    default_value: new Date("2024-01-01T00:00:00.000Z"), // inputWithDate
  },
  {
    param_name: "end_year_month",
    type: "string",
    default_value: new Date("2024-03-01T00:00:00.000Z"), // inputWithDate
  },
  {
    param_name: "Email_To",
    type: "string",
    default_value:
      "rajat.sati@decisionpoint.in;raghav.vashisht@decisionpoint.in;rishabh.krishna@decisionpoint.in;divya.soni@decisionpoint.in;amit.mann@decisionpoint.in", // textDisplay
  },
]
